import React from "react";
import numeral from "numeral";
import { Circle, Popup } from "react-leaflet";

const casesTypeColors = {
  cases: {
    hex: "#39a0ca",
    multiplier: 800,
  },
  recovered: {
    hex: "#3fb0ac",
    multiplier: 1200,
  },
  deaths: {
    hex: "#2d545e",
    multiplier: 2000,
  },
};

export const sortData = (data) => {
  const sortedData = [...data];

  //This is a ternary and is  shorter than an if statement
  return sortedData.sort((a, b) => (a.cases > b.cases ? -1 : 1));
};

//This function is going to prettify the print of the number it will return a nice string
export const prettyPrintStat = (stat) =>
  stat ? `+${numeral(stat).format("0.0a")}` : "+0";

//DRAW circle on the map with interactive tooltips
export const showDataOnMap = (data, casesType = "cases") =>
  data.map((country) => (
    <Circle
      center={[country.countryInfo.lat, country.countryInfo.long]}
      fillOpacity={0.4}
      color={casesTypeColors[casesType].hex}
      fillcolor={casesTypeColors[casesType].hex}
      //you want the circle around the country to represent the cases. You define how large the
      // circle is depending on the number. This helps how to show the data properly
      radius={
        Math.sqrt(country[casesType]) * casesTypeColors[casesType].multiplier
      }
    >
      <Popup>
        {/* div>div*5 this is an emmet way of 
        easily creating one main div and 5 children divs */}
        <div className="info-container">
          <div
            className="info-flag"
            style={{ backgroundImage: `url(${country.countryInfo.flag})` }}
          />
          <div className="info-name">{country.country}</div>
          <div className="info-confirmed">
            Cases: {numeral(country.cases).format("0,0")}
          </div>
          <div className="info-recovered">
            Recovered: {numeral(country.recovered).format("0,0")}
          </div>
          <div className="info-deaths">
            Deaths: {numeral(country.deaths).format("0,0")}
          </div>
        </div>
      </Popup>
    </Circle>
  ));
